import React from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import InfoSection from "../../shared/InfoSection";
import img from "../../../assets/images/list.png";
import { useTranslation } from "react-i18next";

const TeamMemberCard = ({ image, name, role }) => {
  return (
    <Card
      sx={{
        maxWidth: { xs: "100%", md: "352px" },
        borderRadius: 2,
        p: 3,
        border: "1px solid #D6D8DB",
      }}
      elevation={0}
    >
      <CardMedia
        component="img"
        height="240"
        image={image}
        alt={name}
        sx={{ borderRadius: "8px" }}
      />
      <CardContent sx={{ textAlign: "center" }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {role}
        </Typography>
      </CardContent>
    </Card>
  );
};

const TeamSection = ({
  members = [],
  team_description,
  team_sub_description,
}) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          py: 4,
          textAlign: "center",
          maxWidth: "736px",
          overflow: "hidden",
          margin: "0px auto",
        }}
      >
        <InfoSection
          icon={img}
          title={t("buttons.Our Team")}
          description={t("missed.Get to know the people behind our mission")}
          textAlign="center"
        />
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "400",
            color: "#3C3E44",
            lineHeight: "27px",
            my: "40px",
          }}
        >
          {team_description}
        </Typography>
        <Grid container spacing={3} justifyContent="space-between">
          {members.map((member, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <TeamMemberCard
                image={member.image}
                name={member.name[currentLang]}
                role={member.role[currentLang]}
              />
            </Grid>
          ))}
        </Grid>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "400",
            color: "#3C3E44",
            lineHeight: "27px",
            mt: "40px",
          }}
        >
          {team_sub_description}
        </Typography>
      </Box>
    </Container>
  );
};

export default TeamSection;
